import React from 'react'
import { Route } from 'react-router-dom'
import Settings from './Settings'

export default [<Route exact path="/settings" component={Settings} key="1" />]
